import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo lo recibo después de comprar?',
    a: 'Acceso inmediato. Te llega el link/archivo PDF al email del pago (y/o pantalla de descarga).'
  }, {
    q: '¿Sirve si soy nutri recién recibido/a?',
    a: 'Sí: te da estructura, guiones y criterio para no trabarte en consulta.'
  }, {
    q: '¿Sirve si ya tengo experiencia?',
    a: 'Sí: está pensado para ganar velocidad, orden y consistencia sin bajar calidad.'
  }, {
    q: '¿Es para Argentina?',
    a: 'Sí: está hecho para el contexto real del nutri en Argentina y se paga por Mercado Pago.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí: 7 días, devolución total.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-8 px-3 max-w-3xl mx-auto" data-id="element-97">
      <FadeIn data-id="element-98">
        <h2 className="font-display text-2xl md:text-3xl font-bold text-accent text-center mb-5" data-id="element-99">
          PREGUNTAS FRECUENTES
        </h2>
      </FadeIn>

      <div className="space-y-2" data-id="element-100">
        {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-101">
            <div className="bg-surface rounded-lg border border-accent/25 overflow-hidden" data-id="element-102">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full text-left px-4 py-3 flex items-center justify-between font-bold text-accent text-sm hover:bg-accent/5 transition-colors" data-id="element-103">
                <span className="pr-4" data-id="element-104">{faq.q}</span>
                <ChevronDown className={`shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} size={20} data-id="element-105" />
              </button>
              <AnimatePresence data-id="element-106">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-107">
                    <div className="px-4 pb-3 text-white/70 text-sm" data-id="element-108">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}